import { FieldErrors } from 'react-hook-form'
import get from 'lodash/get'
import * as yup from 'yup'

export const HeavyLoadsSchema = yup.object({
  isHeavyLoadCapable: yup.boolean(),
})

export type THeavyLoadsSchema = yup.InferType<typeof HeavyLoadsSchema>

export const getErrorMessage = <T extends FieldErrors<THeavyLoadsSchema>, K extends keyof T>(
  errors: T,
  keyName: K
): string | undefined => {
  return get(errors, [keyName, 'message'])
}
